import { useState } from 'react';
import AccommodationFacilityItem from './AccommodationFacilitiyItem';
import DownCaret from '../Common/icons/DownCaret';
import LayoutConfig from '../../Config/layoutConfig';
import { useSelector } from 'react-redux';

const AccommodationFacilities = props => {

    const Dictionary = useSelector(state => state.VisualData.Dictionary);

    const { facilities } = props;

    const [open, setOpen] = useState(false);

    if (!facilities || !facilities.length) {
        return null;
    }
    
    const isStyle3 = LayoutConfig.themeClassName === 'style-3';
    
    return (
        <div className={`card card-padding bg-white box-border margin-bottom ${isStyle3?"":"blue-border-right"}`}>
            
            <h5 className="normal-title">{Dictionary.hotelFacilities}</h5>

            <div className="facility-columns margin-top-large">

                {facilities.slice(0, 4).map(facility => <AccommodationFacilityItem facility={facility} key={facility.keyword} />)}

                {!!open && facilities.slice(4).map(facility => <AccommodationFacilityItem facility={facility} key={facility.keyword} />)}

            </div>

            <div className="relative text-center moreFacilities-btn-wrapper">
                <div className={`${open?"h-0":"h-18"} more-facilities-gradient`} />
                <button type='button' className='toggle-button' onClick={() => { setOpen(prevState => !prevState) }}>
                    {open ? " بستن " : " امکانات بیشتر "} <DownCaret className={`expand-icon ${open ? "rotate" : ""}`} />
                </button>
            </div>

        </div>
    )
}

export default AccommodationFacilities;